import { setPath } from "@/services/helpers";
import httpClient from "@/store/httpClient";

const endpoint = "/u/tasks";

// Actions
const actions = {
  async retrieveItems({ commit }, options) {
    commit("START_LOADING", "retrieveTaskOps");

    let params = {};

    if (options.meta.page == null) {
      params = {
        page: 1,
        page_size: 500,
        order_by: options.order_by,
      };
    } else if (options.meta.page != null && options.meta.has_next) {
      params = {
        page: options.meta.page + 1,
        page_size: 500,
        order_by: options.order_by,
      };
    } else {
      return;
    }

    httpClient
      .get(endpoint, { params })
      .then((response) => {
        if (response.status === 200) {
          commit("APPEND_ITEMS", response);
          commit("UPDATE_PAGINATION_METADATA", {
            form: "retrieveTaskOps",
            field: "meta",
            response: response,
          });
          commit("STOP_LOADING", "retrieveTaskOps");
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "retrieveTaskOps");
      });
  },
  async searchItem({ commit, dispatch }, payload) {
    commit("START_LOADING", "searchOps");
    httpClient
      .post(`${endpoint}/search`, {
        name: payload,
      })
      .then((response) => {
        if (response.status === 200) {
          dispatch("appendSearchItems", response);
        }
      })
      .catch((error) => {
        console.log(error);
        commit("STOP_LOADING", "searchOps");
      });
  },
};
// Getters
const getters = {};
// Mutations
const mutations = {
  // Loader operations
  START_LOADING(state, name) {
    state[name].isLoading = true;
  },
  STOP_LOADING(state, name) {
    state[name].isLoading = false;
  },
  //   Dialog operations
  // Data operations
  APPEND_ITEMS(state, response) {
    // state.tasks = []; // Flush array before loading data
    response.data.items.forEach((item) => {
      state.tasks.push(item);
    });
  },
  FLUSH_ITEMS(state) {
    state.tasks = [];
  },
  POPULATE_ITEM(state, obj) {
    state.task = Object.assign({}, state.tasks[obj.index]);
  },
  FLUSH_TASK(state) {
    state.task = Object.assign({}, {});
  },
  //   Pagination operations
  UPDATE_SERVER_ITEMS_LENGTH(state, response) {
    state.retrieveTaskOps.serverItemsLength = response.data.meta.total;
  },
  UPDATE_PAGE_NUMBER(state, response) {
    state.retrieveTaskOps.page = response.data.meta.page;
  },
  UPDATE_PAGINATION_METADATA(state, payload) {
    state[payload.form][payload.field] = Object.assign(
      {},
      payload.response.data.meta
    );
  },
  //   Form operations
  UPDATE_FORM(state, { payload }) {
    setPath(state, payload.form, payload.value);
  },
};
// State
const state = {
  tasks: [],
  task: {},
  searchItems: [],
  serverItemsLength: 0,
  retrieveTaskOps: {
    isLoading: false,
    serverItemsLength: 0,
    meta: {
      has_next: null,
      page: null,
      pages: null,
      total: null,
    },
  },
};

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
};
